export default __webpack_public_path__ + "static/pool-5072272e822d878799793558e6bacf46.webp";